import { LogoutButton } from '../buttons/LogoutButtonComponent';
import { useState } from 'react';

function AdminNavMain({ extraNavItems }) {

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    return(
        <div className="max-w-7xl mx-auto" id="admin-nav-bar">
            <nav className="fixed top-0 left-0 right-0 bg-gray-100 shadow-sm z-50">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex items-center justify-between h-14">
                        <a href="/admin" className="text-lg font-bold text-gray-800 no-underline">Admin</a>
                        <button
                            className="sm:hidden p-2 text-gray-600 hover:text-gray-800"
                            onClick={toggle}
                        >
                            <i className="fa-solid fa-bars"></i>
                        </button>
                        <div className={`${isOpen ? 'flex' : 'hidden'} sm:flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 absolute sm:relative top-14 sm:top-0 left-0 right-0 bg-gray-100 sm:bg-transparent p-4 sm:p-0 shadow-md sm:shadow-none`}>
                            <a href={process.env.REACT_APP_FRONTEND_URL + "/admin/images"} className="text-gray-600 hover:text-gray-800 text-sm no-underline">Images</a>
                            <a href={process.env.REACT_APP_FRONTEND_URL + "/admin/quizzes"} className="text-gray-600 hover:text-gray-800 text-sm no-underline">Quizzes</a>
                            <a href={process.env.REACT_APP_FRONTEND_URL + "/admin/users"} className="text-gray-600 hover:text-gray-800 text-sm no-underline">Users</a>
                            <a href={process.env.REACT_APP_FRONTEND_URL + "/admin/games"} className="text-gray-600 hover:text-gray-800 text-sm no-underline">Games</a>
                            {extraNavItems}
                            <LogoutButton />
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default AdminNavMain;
